// @ts-nocheck

import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger"
import SplitText from "../components/splitText";
import Parallax from 'parallax-js'

declare global {
    interface Window {
        animations: any;
    }
}

export const page = async () => {

    animations();
    splitText()

}

function animations(){
    rotateBottle()
    parallax()
    textBottle()
}
window.animations = animations;

function rotateBottle(){
    gsap.registerPlugin(ScrollTrigger);

    var frame_count  = 9,
    offset_value = 100;

    gsap.to(".viewer", {
        backgroundPosition: (-offset_value * frame_count * 2) + "px 50%",
        ease: "steps(" + frame_count + ")", // use a stepped ease for the sprite sheet
        // opacity: 1,
        // duration: 5,
        scrollTrigger: {
            trigger: ".mxmhboxDetail__body__top",
            start: "top 60%",
            // end: "+=" + (frame_count * offset_value),
            end: "600px 10%",
            // markers: true,
            // endTrigger:".content-xmichelob-flavors--section-secondary" ,
            // pin: true,
            scrub: true
        }
    });
}

function splitText(){
    new SplitText("#quote")
    new SplitText("#quote1")
    // new SplitText(".item1")
    // new SplitText(".item2")
    new SplitText(".item3")
    new SplitText(".item4")
    new SplitText(".item5")
    new SplitText(".item6")
    new SplitText(".content-xmichelob-flavors--section-third--title")
}

function parallax(){
    var scene = document.querySelector(".boxParallax");
    var scene1 = document.querySelector(".boxIcons");
    var scene2 = document.querySelector(".boxMiddle");
    var scene3 = document.querySelector(".boxiconsBottom");
    new Parallax(scene);
    new Parallax(scene1);
    new Parallax(scene2);
    new Parallax(scene3);
}

function textBottle(){
    gsap.registerPlugin(ScrollTrigger)
    // gsap.to('.mxmhboxDetail__body__top__content__right--content li', {
    //     opacity: 1,
    //     y: 0,
    //     ease: "power2.inOut",
    //     // duration: 2,
    //     scrollTrigger: {
    //         trigger: '.mxmhboxDetail__body__top__content',
    //         start: 'top center',
    //         end: '400px 40%',
    //         scrub: true,
    //         toggleActions: "play none none none"
    //     },
    // })
    // gsap.to('.mxmhboxDetail__body__top__content__right--content a', {
    //     opacity: 1,
    //     y: 0,
    //     ease: "power2.inOut",
    //     // duration: 2,
    //     scrollTrigger: {
    //         trigger: '.mxmhboxDetail__body__top__content',
    //         start: 'top center',
    //         end: '400px 40%',
    //         scrub: true,
    //         toggleActions: "play none none none"
    //     },
    // })

    gsap.to('.iconbottleFruit', {
        // scale: 0,
        y: -40,
        x: 120,
        // opacity: 1,
        duration: 10,
        ease: 'none',
        scrollTrigger: {
            trigger: '.mxmhboxDetail__body__top__content',
            start: 'top center',
            end: '400px 40%',
            scrub: true,
            // markers: true,
            toggleActions: "play none none none"
        },
    })
    gsap.to('.iconbottleFruit1', {
        // scale: 0,
        y: 150,
        x: -115,
        // opacity: 1,
        duration: 10,
        ease: 'none',
        scrollTrigger: {
            trigger: '.mxmhboxDetail__body__top__content',
            start: 'top center',
            end: '300px 40%',
            scrub: true,
            toggleActions: "play none none none"
        },
    })
    gsap.to('.iconbottle', {
        // scale: 0,
        y: 380,
        x: 115,
        // opacity: 1,
        duration: 10,
        ease: 'none',
        scrollTrigger: {
            trigger: '.mxmhboxDetail__body__top__content',
            start: 'top center',
            end: '300px 40%',
            scrub: true,
            toggleActions: "play none none none"
        },
    })
    gsap.to('.iconbottle1', {
        // scale: 0,
        y: -240,
        x: -170,
        // opacity: 1,
        duration: 10,
        ease: 'none',
        scrollTrigger: {
            trigger: '.mxmhboxDetail__body__top__content',
            start: 'top center',
            end: '300px 40%',
            scrub: true,
            toggleActions: "play none none none"
        },
    })
}